import { AuthService } from "@auth0/auth0-angular";
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, switchMap, take } from "rxjs";
import { inject } from "@angular/core/primitives/di";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { environment } from "src/environments/environment";
import { ResolverHelper } from "./resolver.helper";

export const CommercialAppraisalResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    return ResolverHelper.hasPermission(authService, EVServiceType.Internal_Debug).pipe(
        take(1),
        switchMap((hasDebugRole) => {
            return ResolverHelper.hasPermission(authService, [EVServiceType.CommercialEstateAppraisal_Realtor]).pipe(
                take(1),
                switchMap((hasCommercialAppraisalRole) => {
                    if (hasCommercialAppraisalRole) {
                        if (hasDebugRole) {
                            window.open(environment.commercialAppraisalUrl + "/dashboard?login_hint=eiendomsverdi.no", "_self");
                            return EMPTY;
                        }
                    }
                    console.log("Brukeren har ikke rettigheter til å åpne næringstakstoversikten. Sender til forsiden.");
                    return ResolverHelper.redirectToFrontPage(authService, router);
                }),
            );
        }),
    );
};
